import React from "react";
import ProductCard from "../../ProductCard";

import { Col, Row } from "react-bootstrap";
import "./index.scss";
export const ProduitAssocie = ({ products }) => {
  return (
    <div className="product-section">
      <Row>
        {products.map((product) => (
          <Col key={product.id} md={3} sm={6} xs={12} className="mb-4">
            <ProductCard product={product} />
          </Col>
        ))}
      </Row>
    </div>
  );
};
